import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { extractId } from "../utils/transformers";
import { toIsoRange, parseSaleStatsParams } from "../pages/dashboard/admin/saleStatsRange";

export const MarketplaceContext = createContext(null);

MarketplaceContext.propTypes = {
    children: PropTypes.node,
};

export function MarketplaceProvider({ children }) {

    const [marketplace, setMarketplace] = useState()
    const [marketplaceAccountsSellers, setMarketplaceAccountsSellers] = useState([])
    const [marketplaceCharts, setMarketplaceCharts] = useState(null) // 'seats.io' charts which belongs to a marketplace
    const [marketplaceSaleStats, setMarketPlaceSaleStats] = useState(null)
    const [marketplaceGeneraleSaleStats, setMarketPlaceGeneraleSaleStats] = useState(null)
    // Seeded from the URL so a reload or a shared link keeps the chosen range.
    // Read synchronously on first render (and via window.location, since this
    // provider sits above BrowserRouter): MarketSaleStatsGuard keys its fetch on
    // this value, so resolving it in an effect instead would fire one wasted
    // request for the default window before the real one.
    const [saleStatsRange, setSaleStatsRange] = useState(() => {
        const { from, to } = parseSaleStatsParams(window.location.search);
        return toIsoRange(from, to);
    });
    const [saleStatsLoading, setSaleStatsLoading] = useState(true);

    return (
        <MarketplaceContext.Provider
            value={{
                marketplace,
                setMarketplace,
                marketplaceAccountsSellers,
                setMarketplaceAccountsSellers,
                marketplaceCharts,
                setMarketplaceCharts,
                marketplaceSaleStats,
                setMarketPlaceSaleStats,
                marketplaceGeneraleSaleStats,
                setMarketPlaceGeneraleSaleStats,
                saleStatsRange,
                setSaleStatsRange,
                saleStatsLoading,
                setSaleStatsLoading
            }}
        >
            {children}
        </MarketplaceContext.Provider>
    );
}

export const useMarketplaceContext = () => {
    const context = useContext(MarketplaceContext);

    if (!context) throw new Error('MarketplaceContext context must be use inside MarketplaceProvider');

    return context;
};
